import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import { authService } from '@/services/auth.service';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-background">
      <div className="w-full max-w-sm">
        <Link to="/login" className="flex items-center gap-2 text-gray-500 hover:text-gray-700 text-sm mb-8">
          <ArrowLeft className="h-4 w-4" /> Back to Login
        </Link>

        {sent ? (
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-primary-50 flex items-center justify-center mx-auto mb-4">
              <Mail className="h-8 w-8 text-primary-500" />
            </div>
            <h2 className="font-heading font-bold text-xl text-gray-800 mb-2">Check Your Email</h2>
            <p className="text-gray-500 text-sm">If <strong>{email}</strong> is registered, you'll receive a reset link shortly.</p>
            <Link to="/login" className="mt-6 inline-block text-primary-600 font-semibold">Return to Login</Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-bold text-2xl text-gray-800 mb-1">Forgot Password?</h1>
            <p className="text-gray-500 text-sm mb-8">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input label="Email Address" type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required />
              <Button type="submit" className="w-full" loading={loading}>Send Reset Link</Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
